<div class="attraction-list">
  <h2>{{ 'ATTRACTION.ATTRACTION_IN' | translate: { country: countryName | replaceStr: ' ' | titlecase } }}</h2>

  <div class="attraction-list__content">
    <div class="swiper" appSwiper [swiperOptions]="swiperOptions">
      <div class="swiper-wrapper">
        @for (attraction of attractions | slice: 0 : 50; track attraction.place_id) {
          <div class="swiper-slide">
            <app-attraction-card-mobile
              [countryName]="countryName"
              [attraction]="attraction"
            ></app-attraction-card-mobile>
          </div>
        }
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
